import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dismissNotification } from '../actions'
import { onCreateListing } from '../../listing/manage-listing-component';
import * as constants from '../constants';
import moment from 'moment';

import RatingForm from '../../../global/forms/ratingForm';
import ContactForm from '../../../global/forms/contactForm';

import { getAndReplaceBooking } from '../../bookings/actions';
import { addNewReview } from '../../actions';

const mapStateToProps = state => ({
  global: state.Global,
  dashboard: state.Dashboard
});

class NotificationGeneralComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false
    }

    this.dismiss = this.dismiss.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitRatingModal = this.submitRatingModal.bind(this);
    this.loadAdditionalData = this.loadAdditionalData.bind(this);
  }

  componentDidMount() {
    let { notification, booking } = this.props;
    if (notification && notification.booking && (!booking || !booking.userId)) {
      setTimeout(this.loadAdditionalData, 500);
    }
  }

  loadAdditionalData() {
    let { notification, booking, dispatch } = this.props;
    if (notification && notification.booking && (!booking || !booking.userId)) {
      dispatch(getAndReplaceBooking(notification.booking));
    }
  }

  dismiss() {
    let { notification, dispatch } = this.props;
    dispatch(dismissNotification(notification));
  }

  navigateTo(link) {
    let { history } = this.props;
    this.dismiss();
    history.push(link);
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  submitRatingModal = (values) => {
    let { dispatch } = this.props;
    dispatch(addNewReview(values, () => {
      this.closeModal();
      this.dismiss();
    }));
  }

  submitContactModal = (values) => {
    this.closeModal();
    this.dismiss();
  }

  renderTitle(notificationType, booking) {
    switch (notificationType) {
      case constants.TYPE_OWNER_WELCOME:
        return 'Welcome to CollegeWeekends.com';
      case constants.TYPE_RENTER_WELCOME:
        return 'Welcome';
      case constants.TYPE_OWNER_BOOKING_CONFIRM:
      case constants.TYPE_RENTER_BOOKING_CONFIRM:
        return 'Booking Confirmation';
      case constants.TYPE_OWNER_BOOKING_ONEWEEK:
      case constants.TYPE_OWNER_BOOKING_ONEDAY:
      case constants.TYPE_RENTER_BOOKING_ONEDAY:
        return 'Booking Reminder';
      case constants.TYPE_OWNER_BOOKING_CHECKOUT:
        return 'How Did Your Guest Do?';
      case constants.TYPE_OWNER_BOOKING_APPROVED_FAILURE:
        return 'Booking Payment Failure';
      case constants.TYPE_OWNER_BOOKING_CANCEL:
      case constants.TYPE_RENTER_BOOKING_CANCEL:
        return 'Booking Cancellation';
      case constants.TYPE_RENTER_BOOKING_DENIED:
        return 'Sorry, Booking Request Denied';
      case constants.TYPE_RENTER_BOOKING_ONEWEEK:
        return 'Get Ready For Your Stay!';
      case constants.TYPE_RENTER_BOOKING_CHECKOUT:
        return 'Review Your Stay';
      case constants.TYPE_RENTER_BOOKING_DISPUTE:
        return 'Damage Deposit Disputed';
      case constants.TYPE_NEW_MESSAGE:
        return 'New Message';
      default:
        return `General Notification`;
    }
  }

  renderNotificationActions(notification) {
    let notificationType = notification.notificationType;
    switch (notificationType) {
      case constants.TYPE_OWNER_WELCOME:
        //Link to create new listing
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={() => onCreateListing(this.props)}>Create New Listing</button>
        </div>);
      case constants.TYPE_RENTER_WELCOME:
      case constants.TYPE_RENTER_BOOKING_DENIED:
        //Link to search listings
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={() => this.navigateTo('/search')}>Search Listings</button>
        </div>);
      case constants.TYPE_OWNER_BOOKING_CONFIRM:
      case constants.TYPE_OWNER_BOOKING_ONEDAY:
      case constants.TYPE_RENTER_BOOKING_CONFIRM:
      case constants.TYPE_RENTER_BOOKING_ONEDAY:
      case constants.TYPE_OWNER_BOOKING_APPROVED_FAILURE:
        //Link to booking
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={() => this.navigateTo(`/dashboard/bookings/${notification.booking}`)}>View Booking</button>
        </div>);
      case constants.TYPE_OWNER_BOOKING_ONEWEEK:
        //Message modal
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={this.openModal}>Send Message</button>
        </div>);
      case constants.TYPE_OWNER_BOOKING_CHECKOUT:
      case constants.TYPE_RENTER_BOOKING_CHECKOUT:
        //Message modal
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={this.openModal}>Leave Review</button>
        </div>);
      case constants.TYPE_RENTER_BOOKING_CONFIRM:
        //Link to booking
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={() => this.navigateTo(`/dashboard/bookings/${notification.booking}`)}>View Listing</button>
          <button className="btn btn-secondary" onClick={() => this.navigateTo(`/dashboard/bookings/${notification.booking}`)}>View Booking</button>
        </div>);
      case constants.TYPE_NEW_MESSAGE:
        //Link to inbox
        return (<div className="mt-2">
          <button className="btn btn-secondary" onClick={() => this.navigateTo(`/dashboard/inbox`)}>View Inbox</button>
        </div>);
      default:
        return false;
    }
  }

  renderModal(notification, booking) {
    let { notificationType } = notification;
    //notification, `, 'user'
    let values = {};
    switch (notificationType) {
      case constants.TYPE_OWNER_BOOKING_ONEWEEK:
        values.contactUser = booking.userId;
        return (<ContactForm onSubmit={this.submitContactModal} onClose={this.closeModal} values={values} />)
      case constants.TYPE_OWNER_BOOKING_CHECKOUT:
        values.title = `Review guest ${booking.userId.firstName} ${booking.userId.lastName.substr(0, 1)}`;
        values.id = booking._id;
        values.type = "user"
        return (<RatingForm onSubmit={this.submitRatingModal} onClose={this.closeModal} values={values} />);
      case constants.TYPE_RENTER_BOOKING_CHECKOUT:
        values.title = `Review stay at ${booking.listingId.listingName}`;
        values.id = booking._id;
        values.type = "listing"
        return (<RatingForm onSubmit={this.submitRatingModal} onClose={this.closeModal} values={values} />);
      default:
        return (<div />);
    }
  }

  render() {
    let { notification, booking } = this.props;
    if (!notification) {
      return (<div>Loading...</div>)
    }
    return (<div className="row dashboard-notification">
      <div className="col-10 notification-text">
        <div className="">
          <strong>{this.renderTitle(notification.notificationType, booking)}</strong>
        </div>
        <div className="">
          {notification.message}
        </div>
        {!notification.dismissed && this.renderNotificationActions(notification)}
      </div>
      <div className="col-2 notification-status">
        <div className="text-right">
          <span>{moment(notification.createdDate).fromNow()}</span>
        </div>
        {!notification.dismissed
          && (<div className="dismiss"><a onClick={this.dismiss}><span>Dismiss</span></a></div>)
        }
      </div>
      {this.state.modalOpen && this.renderModal(notification, booking)}
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(NotificationGeneralComponent));
